import { mostraAlertaError, mostraAlertaOk, mostraAlertaWarning } from "../../../componentes/alerts/sweetAlert";
import { AxiosPrivado } from "../../../componentes/axios/Axios";
import ModalBootstrap from "../../../componentes/modal/ModalBootstrap";
import { CargosEditar, CargosGuardar, CargosListar } from '../../../configuracion/apiUrls';
import { useEffect, useState } from "react"
import { regexNombre } from "../../../configuracion/validaciones";

const ModalCargo = ({ datos, token, setListaCargos, ActualizarLista }) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [id, setId] = useState(datos ? datos.id : null);
    const [nombre_cargo, setNombre] = useState(datos ? datos.nombre_cargo : '');
    const [estado, setEstado] = useState(datos ? datos.estado : 'Activo');
    const [errorNombre, setErrorNombre] = useState(false);

    useEffect(() => {
        if (regexNombre.test(nombre_cargo))
            setErrorNombre(false)
        else
            setErrorNombre(true)

    }, [nombre_cargo])
    useEffect(() => {
        if (modalIsOpen) {
            setNombre(datos ? datos.nombre_cargo : '');
            setEstado(datos ? datos.estado : 'Activo');
            setId(datos ? datos.id : null)
        }
    }, [modalIsOpen])

    const BotonGuardar = () => {
        return (
            <button type="button" className="btn btn-success" onClick={guardarCargo}>Guardar</button>
        )
    }
    const BotonEditar = () => {
        return (
            <button type="button" className="btn btn-warning text-white" onClick={editarCargo}>
                Editar
                <i className="fas fa-edit ml-2" />
            </button>
        )
    }
    const guardarCargo = () => {
        if (errorNombre) {
            mostraAlertaWarning("El nombre del cargo debe tener entre 3 y 50 caracteres y solo puede contener letras");
        }
        else {
            try {
                AxiosPrivado.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                AxiosPrivado.post(CargosGuardar, { nombre_cargo, estado })
                    .then((respuesta) => {
                        mostraAlertaOk("Registro guardado correctamente");
                        ActualizarLista(CargosListar, setListaCargos);
                        setModalIsOpen(false);
                    }).catch((er) => {
                        console.log(er);
                        var msjError = "";
                        switch (er.response.status) {
                            case 400:
                                if (er.response.data && Array.isArray(er.response.data)) {
                                    er.response.data.map(f => {
                                        msjError += f.msg + '. '
                                    })
                                }
                                break;
                            case 404:
                                msjError = "Ruta no entrontrada en la api";
                                break;
                            case 500:
                                msjError = er.response.data.error;
                                break;
                            default:
                                msjError = "Ocurrió un error desconocido.";
                                break;
                        }
                        mostraAlertaError(msjError, "error");
                    })
            } catch (error) {
                mostraAlertaError("Error en la pedición")
            }
        }

    }
    const editarCargo = () => {
        if (!id)
            mostraAlertaError("Seleccione un cargo");
        else if (errorNombre) {
            mostraAlertaWarning("El nombre del cargo debe tener entre 3 y 50 caracteres");
        }
        else {
            try {
                AxiosPrivado.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                AxiosPrivado.put(CargosEditar + id, { nombre_cargo, estado })
                    .then((respuesta) => {
                        mostraAlertaOk("Registro actualizado correctamente");
                        ActualizarLista(CargosListar, setListaCargos);
                        setModalIsOpen(false);
                    }).catch((er) => {
                        console.log(er);
                        var msjError = "";
                        switch (er.response.status) {
                            case 400:
                                if (er.response.data && Array.isArray(er.response.data)) {
                                    er.response.data.map(f => {
                                        msjError += f.msg + '. '
                                    })
                                }
                                break;
                            case 400:
                                msjError = er.response.data.error;
                                break;
                            case 500:
                                msjError = er.response.data.error;
                                break;
                            default:
                                msjError = "Ocurrió un error desconocido.";
                                break;
                        }
                        mostraAlertaError(msjError, "error");
                    })
            } catch (error) {
                mostraAlertaError("Error en la pedición")
            }
        }

    }

    return (
        <ModalBootstrap
            titulo={datos ? "Editar Cargo" : "Nuevo Cargo"}
            nombreBoton={datos ? "" : "Nuevo Cargo"}
            estiloBoton={datos ? "btn btn-outline-primary" : "btn btn-info"}
            iconBoton={datos ? "fas fa-edit mx-0" : "fas fa-briefcase"}
            pie={datos ? <BotonEditar /> : <BotonGuardar />}
            modalIsOpen={modalIsOpen}
            setModalIsOpen={setModalIsOpen}
            size={'sx'}
        >
            <div className="row">
                <div className="col-lg-8 col-sm-12">
                    <div className="form-group">
                        <label htmlFor="primerNombre">Nombre</label>
                        <input
                            type="text"
                            className={`form-control ${errorNombre ? "is-invalid" : ""
                                }`}
                            id="text"
                            placeholder="Nombre"
                            name="nombre_cargo"
                            value={nombre_cargo}
                            onChange={e => setNombre(e.target.value)}
                        />
                        <span id="nombre_cargo-error" className="error invalid-feedback">
                        El nombre del cargo debe tener entre 3 y 50 caracteres y solo puede contener letras
                        </span>

                    </div>
                </div>
                <div className="col-lg-4 col-sm-12">
                    <div className="form-group">
                        <label htmlFor="activo">
                            Estado
                        </label>
                        <div className="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
                            <input
                                type="checkbox"
                                className="custom-control-input"
                                id="customSwitch3"
                                name="activo"
                                checked={estado == "Activo" ? true : false}
                                onChange={(event) => {
                                    setEstado(event.target.checked ? "Activo" : "Inactivo")
                                }}
                            />
                            <label
                                className="custom-control-label"
                                htmlFor="customSwitch3"
                            >
                                {estado}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </ModalBootstrap>
    );
}
export default ModalCargo;